import { ActionTypes } from "../action-type";

const initialState = {
    pause:true,
    team:false
};

export const debateTimerReducer = (state=initialState,action)=>{
    switch(action.type){
        case ActionTypes.TIMER:
            return{...state,
                pause:action.payload.pause,
                team:action.payload.team
            }
        
        default:
            return state;
    }

}